// Translation: External > Provider button (Russian)
export default Object.freeze({
	continueWithProvider: '',
	signUpWithProvider: '',
	signInWithProvider: ''
})
